export default "__VITE_ASSET__DRPXXs8X__"